import { createSlice } from "@reduxjs/toolkit";
import {
  fetchCashierPayments,
  addCashierPayment,
  updateCashierPayment,
  deleteCashierPayment,
} from "./cashierPaymentsThunks";

const initialState = {
  items: [],
  loading: false,
  error: null,
};

const cashierPaymentsSlice = createSlice({
  name: "cashierPayments",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchCashierPayments.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchCashierPayments.fulfilled, (state, action) => {
      state.loading = false;
      state.items = action.payload || [];
    });
    builder.addCase(fetchCashierPayments.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(addCashierPayment.fulfilled, (state, action) => {
      state.items.push(action.payload);
    });
    builder.addCase(updateCashierPayment.fulfilled, (state, action) => {
      const idx = state.items.findIndex(item => item.id === action.payload.id);
      if (idx !== -1) {
        state.items[idx] = action.payload;
      }
    });
    builder.addCase(deleteCashierPayment.fulfilled, (state, action) => {
      state.items = state.items.filter(item => item.id !== action.payload);
    });
  },
});

export default cashierPaymentsSlice.reducer;
